import React from 'react'
import IndexRouter from './router/IndexRouter'
import './App.css'

export default function App() {
  return (
    <div>
        <IndexRouter></IndexRouter>
    </div>
  )
}
